<template>
    <header class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-light">
            <!-- ============================================================== -->
            <!-- Logo -->
            <!-- ============================================================== -->
            <div class="navbar-header">
                <a class="navbar-brand" href="/">
                  <b>
                    <img src="../../assets/images/logo-light-icon.png" width="40" alt="homepage" class="light-logo" />
                        </b>
                    <span>
                      <img src="../../assets/images/logo-light-text.png" class="light-logo" alt="homepage" /></span> </a>
            </div>
            <!-- ============================================================== -->
            <!-- End Logo -->
            <!-- ============================================================== -->
            <div class="navbar-collapse">
                <!-- ============================================================== -->
                <!-- toggle and nav items -->
                <!-- ============================================================== -->
                <ul class="navbar-nav mr-auto mt-md-0">
                   <li class="nav-item"> <a @click="sideBarToggler" class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
                   <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)">{{ locationName }}</a> </li>

                </ul>
                
                <!-- ============================================================== -->
                <!-- User profile and search -->
                <!-- ============================================================== -->
                <ul class="navbar-nav my-lg-0">

                  <li class="nav-item" v-if=isConnected><div class="nav-link" style='color:white;font-size:12px'>Server Online</div></li>
                  <li class="nav-item" v-if=!isConnected><div class="nav-link" style='color:white;font-size:12px'>Server Offline</div></li>
                    <!-- ============================================================== -->
                    <!-- Comment -->
                    <!-- ============================================================== -->
                    <li class="nav-item dropdown hide">
                        <a class="nav-link dropdown-toggle text-muted text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="mdi mdi-message"></i>
                            <div class="notify"> <span class="heartbit"></span> <span class="point"></span> </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right mailbox scale-up">
                            <ul>
                                <li>
                                    <div class="drop-title">Notifications</div>
                                </li>
                                <li>
                                  <div class="message-center">
                                      <!-- Message -->
                                      <a href="#">
                                          <div class="btn btn-danger btn-circle"><i class="fa fa-link"></i></div>
                                          <div class="mail-contnet">
                                              <h5>Luanch Admin</h5> <span class="mail-desc">Just see the my new admin!</span> <span class="time">9:30 AM</span> </div>
                                      </a>
                                      <!-- Message -->
                                      <a href="#">
                                          <div class="btn btn-success btn-circle"><i class="ti-calendar"></i></div>
                                          <div class="mail-contnet">
                                              <h5>Event today</h5> <span class="mail-desc">Just a reminder that you have event</span> <span class="time">9:10 AM</span> </div>
                                      </a>
                                      <!-- Message -->
                                      <a href="#">
                                          <div class="btn btn-info btn-circle"><i class="ti-settings"></i></div>
                                          <div class="mail-contnet">
                                              <h5>Settings</h5> <span class="mail-desc">You can customize this template as you want</span> <span class="time">9:08 AM</span> </div>
                                      </a>
                                      <!-- Message -->
                                      <a href="#">
                                          <div class="btn btn-primary btn-circle"><i class="ti-user"></i></div>
                                          <div class="mail-contnet">
                                              <h5>Pavan kumar</h5> <span class="mail-desc">Just see the my admin!</span> <span class="time">9:02 AM</span> </div>
                                      </a>
                                    </div>
                                </li>
                                <li>
                                    <a class="nav-link text-center" href="javascript:void(0);"> <strong>Check all notifications</strong> <i class="fa fa-angle-right"></i> </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End Comment -->
                    <!-- ============================================================== -->
                    <!-- ============================================================== -->
                    <!-- Messages -->
                    <!-- ============================================================== -->
                    <li class="nav-item dropdown hide">
                        <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" id="2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="mdi mdi-email"></i>
                            <div class="notify"> <span class="heartbit"></span> <span class="point"></span> </div>
                        </a>
                        <div class="dropdown-menu mailbox dropdown-menu-right scale-up" aria-labelledby="2">
                            <ul>
                                <li>
                                    <div class="drop-title">You have 4 new messages</div>
                                </li>
                                <li>
                                    <div class="message-center">
                                        <!-- Message -->
                                        <a href="#">
                                            <div class="user-img"> <img src="../../assets/images/users/1.jpg" alt="user" class="img-circle"> <span class="profile-status online pull-right"></span> </div>
                                            <div class="mail-contnet">
                                                <h5>Pavan kumar</h5> <span class="mail-desc">Just see the my admin!</span> <span class="time">9:30 AM</span> </div>
                                        </a>
                                        <!-- Message -->
                                        <a href="#">
                                            <div class="user-img"> <img src="../../assets/images/users/2.jpg" alt="user" class="img-circle"> <span class="profile-status busy pull-right"></span> </div>
                                            <div class="mail-contnet">
                                                <h5>Sonu Nigam</h5> <span class="mail-desc">I've sung a song! See you at</span> <span class="time">9:10 AM</span> </div>
                                        </a>
                                        <!-- Message -->
                                        <a href="#">
                                            <div class="user-img"> <img src="../../assets/images/users/3.jpg" alt="user" class="img-circle"> <span class="profile-status away pull-right"></span> </div>
                                            <div class="mail-contnet">
                                                <h5>Arijit Sinh</h5> <span class="mail-desc">I am a singer!</span> <span class="time">9:08 AM</span> </div>
                                        </a>
                                        <!-- Message -->
                                        <a href="#">
                                            <div class="user-img"> <img src="../../assets/images/users/4.jpg" alt="user" class="img-circle"> <span class="profile-status offline pull-right"></span> </div>
                                            <div class="mail-contnet">
                                                <h5>Pavan kumar</h5> <span class="mail-desc">Just see the my admin!</span> <span class="time">9:02 AM</span> </div>
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <a class="nav-link text-center" href="javascript:void(0);"> <strong>See all e-Mails</strong> <i class="fa fa-angle-right"></i> </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <!-- ============================================================== -->
                    <!-- End Messages -->
                    <!-- ============================================================== -->
                    <!-- ============================================================== -->
                    <!-- Profile -->
                    <!-- ============================================================== -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="../../assets/images/users/1.jpg" alt="user" class="profile-pic" /></a>
                        <div class="dropdown-menu dropdown-menu-right scale-up">
                            <ul class="dropdown-user">
                              <li>
                                <div class="dw-user-box">
                                  <div class="u-img">
                                    <img src="../../assets/images/users/1.jpg" alt="user">
                                    </div>
                                  <div class="u-text">
                                      <h4>{{ userName }}</h4>
                                      <p class="text-muted">{{ email | limitValue }}</p>
                                      <a href="#" class="btn btn-rounded btn-danger btn-sm" v-on:click='sendTest'>View Profile</a></div>
                                  </div>
                                </li>
                                <li role="separator" class="divider"></li>
                                <li>
                                    <a href="#"><i class="ti-user"></i> My Profile</a>
                                </li>
                                <li role="separator" class="divider"></li>
                                <li @click="logout()"><a href="#"><i class="fa fa-power-off"></i> Logout</a></li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
  export default {
    props: ['isConnected'],
    data () {
      return {
        userName: '',
        email: '',
        locationName: '',
        locationCode: this.$ls.get('locationCode')
      }
    },
    filters: {
      limitValue (value) {
        if (value) {
          return value.substring(0, 16) + '...'
        }
      }
    },
    sockets: {
      connect: function () {
        this.$socket.emit('join', {locationCode: this.locationCode})
        console.log('connected to socket')
      },
      global: function (val) {
        console.log(val)
      }
    },
    methods: {
      setScrollBar () {
        $('.message-center').slimScroll({
          position: 'right',
          size: '5px',
          color: '#5C6A71'
        })
      },
      sendTest () {
        console.log('sent test')
        this.$socket.emit('testing', {test: 'test'})
      },
      checkDrawerStatus () {
        let drawer = this.$ls.get('CashDrawerId')
        if (drawer === null) {
          this.$store.state.isShiftOpen = false
        } else {
          this.$http.get('cashDrawer/' + drawer)
          .then(drawerResult => {
            if (!drawerResult.data.available) {
              this.$store.state.isShiftOpen = true
            } else {
              this.$store.state.isShiftOpen = false
            }
          })
        }
      },
      closeShift () {
        this.$modal.show('close-shift')
      },
      openShift () {
        this.$modal.show('open-shift')
      },
      logout () {
        this.$router.push({name: 'login'})
        this.$ls.remove('CashDrawerId')
        this.$ls.remove('token')
      },
      getLogedinUser () {
        return this.$http.get('employee/current').then(response => {
          this.userName = response.body.data.name
          this.email = response.body.data.email
        })
      },
      getLocationInfo () {
        return this.$http.post('', {code: this.locationCode})
        .then(response => {
          this.$ls.set('CountryCode', response.body.data.Address.CountryCode)
          this.$ls.set('StateId', response.body.data.Address.StateId)
          this.locationName = response.body.data.name
        })
      },
      sideBarToggler () {
        if ($('body').hasClass('mini-sidebar')) {
          $('body').trigger('resize')
          $('.scroll-sidebar, .slimScrollDiv').css('overflow', 'hidden').parent().css('overflow', 'visible')
          $('body').removeClass('mini-sidebar')
          $('.navbar-brand span').show()
          // $('.sidebartoggler i').addClass('ti-menu')
        } else {
          $('body').trigger('resize')
          $('.scroll-sidebar, .slimScrollDiv').css('overflow-x', 'visible').parent().css('overflow', 'visible')
          $('body').addClass('mini-sidebar')
          $('.navbar-brand span').hide()
          // $('.sidebartoggler i').removeClass('ti-menu')
        }
      }
    },
    mounted () {
      $('.fix-header .topbar').stick_in_parent({})
      this.setScrollBar()
      // this.getLogedinUser()
      // this.getLocationInfo()
      // this.checkDrawerStatus()
    //   this.orgName = this.$ls.get('organization').name
    //   this.user = this.$ls.get('user')
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Layout/Header.vue